import { ConstrainMode, IColumn, mergeStyleSets } from '@fluentui/react';
import { IPDetailsList, IPIcon, IPLink, IPScrollablePane, IPSpinner, IPStack, IPText } from 'baseComponents';
import { IPDetailsListLayoutMode } from 'baseComponents/DetailsList/IPDetailsList';
import { IPScrollbarVisibility } from 'baseComponents/ScrollablePane/IPScrollablePane';
import { IPSpinnerSize } from 'baseComponents/Spinner/IPSpinner';
import { IDrive } from '../../services/Graph/SharepointInterfaces';
import { IPSelectionMode } from "baseComponents/Utils/Selection";

interface IMyDrivesProps {
  drives: IDrive[];
  onSelect: (item: IDrive) => void;
  isDriveLoading: boolean;
}

const MyDrives = (props: IMyDrivesProps) => {
  const columns: IColumn[] = [
    {
      key: 'icon',
      minWidth: 15,
      maxWidth: 15,
      onRender: () => {
        return (
          <IPStack verticalAlign="center">
            <IPIcon iconName={'BulletedList2'} className={classes.icon} />
          </IPStack>
        );
      },
      name: '',
    },
    {
      key: 'drive',
      minWidth: 200,
      name: '',
      onRender: (item?: IDrive, index?: number | undefined, column?: IColumn | undefined) => {
        if (!item) return;

        return (
          <IPText>
            <IPLink underline onClick={() => props.onSelect(item)} disabled={props.isDriveLoading}>
              {item.name}
            </IPLink>
          </IPText>
        );
      },
    },
  ];

  const classes = mergeStyleSets({
    icon: {
      fontSize: '16px',
    },
  });

  if (props.isDriveLoading) {
    return (
      <IPStack verticalAlign="center" grow verticalFill>
        <IPSpinner size={IPSpinnerSize.large} />
      </IPStack>
    );
  }

  return (
    <IPStack verticalFill>
      <IPStack.Item grow styles={{ root: { position: 'relative' } }}>
        <IPScrollablePane scrollbarVisibility={IPScrollbarVisibility.auto}>
          <IPDetailsList
            columns={columns}
            items={props.drives}
            isHeaderVisible={false}
            layoutMode={IPDetailsListLayoutMode.justified}
            constrainMode={ConstrainMode.unconstrained}
            selectionMode={IPSelectionMode.none}
          />
        </IPScrollablePane>
      </IPStack.Item>
    </IPStack>
  );
};

export default MyDrives;
